import { FC } from "react";
import { Alert } from "@hightouch/htui";
import { LinkButton, useLocation } from "src/router";
import * as analytics from "src/lib/analytics";
import { useUser } from "src/contexts/user-context";
import { useDbtSyncConfigsQuery } from "src/graphql";
import { checkBelowMinimumDbtVersion } from "src/utils/dbt";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { useFlags } from "launchdarkly-react-client-sdk";

const DBT_MIN_VERSION = "1.10";

export const DbtDeprecationBanner: FC = () => {
  const { workspace } = useUser();
  const { appShowDbtDeprecationBanner } = useFlags();
  const location = useLocation();

  const isDbtConfigPage = location.pathname.includes(
    "/extensions/dbt-models/configuration",
  );

  const { isPermitted } = useResourcePermission({
    v2: {
      resource: "workspace",
      grant: "can_update",
    },
  });

  const { data: dbtSyncConfigsData } = useDbtSyncConfigsQuery(
    {},
    { enabled: isPermitted && !isDbtConfigPage },
  );

  const isDbtConfigDeprecated = dbtSyncConfigsData?.getDbtSyncConfigs?.some(
    ({ enabled, version }) =>
      enabled && checkBelowMinimumDbtVersion(version || "", DBT_MIN_VERSION),
  );

  if (
    !workspace ||
    !dbtSyncConfigsData ||
    isDbtConfigPage ||
    !isDbtConfigDeprecated ||
    !isPermitted ||
    !appShowDbtDeprecationBanner
  ) {
    return null;
  }

  analytics.track("dbt deprecation banner shown", {
    workspace_id: workspace?.id,
  });

  return (
    <Alert
      variant="banner"
      type="warning"
      title="Your dbt version is out of date."
      message="To continue using the dbt Core extension, please upgrade to v1.10+"
      actions={
        <LinkButton
          variant="secondary"
          href="/extensions/dbt-models/configuration"
          onClick={() => {
            analytics.track("dbt deprecation banner clicked", {
              workspace_id: workspace?.id,
            });
          }}
        >
          Go to dbt config
        </LinkButton>
      }
    />
  );
};
